(() => {
  document.querySelectorAll('[data-j-dish-choice]').forEach((root) => {
    const controls = root.querySelector('[data-j-dish-buttons]');
    const buttons = [...root.querySelectorAll('[data-j-dish-button]')];
    const panels = [...root.querySelectorAll('[data-j-dish-panel]')];
    if (!controls || buttons.length !== panels.length) return;
    const select = (key, animate = false) => {
      buttons.forEach((button) => button.setAttribute('aria-expanded', String(button.dataset.jDishButton === key)));
      panels.forEach((panel) => {
        const active = panel.dataset.jDishPanel === key;
        panel.open = active;
        if (active && animate && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const content = panel.querySelector('.j-dish-choice__panel');
          content.getAnimations().forEach((animation) => animation.cancel());
          content.animate([{ opacity: .4, transform: 'translateY(6px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 280, easing: 'ease-out' });
        }
      });
    };
    select(buttons[0].dataset.jDishButton);
    root.classList.add('is-enhanced');
    controls.hidden = false;
    buttons.forEach((button) => button.addEventListener('click', () => select(button.dataset.jDishButton, true)));
  });
})();
